<template>
  <SmallSquare content="如果已经关联赋码的标签出现损坏或者无法读取，为保证数据准确性，可以使用此功能进行替换，替换后的标签自动作废；" :padding='true' />
  <a-card :bordered='false'>
    <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="损坏二维码" name='damage_code_sn'>
        <a-input class='width60 m-r-15'  style="width:200px" v-model:value="damage_code_sn" placeholder="请输入损坏二维码" />
        <a-button type="primary" @click='damageCode'>确定</a-button>
        <p v-if='damage_show'>
          类型：
          <span v-if='damage_code_result.code_type == 1'>大标</span>
          <span v-if='damage_code_result.code_type == 2'>中标</span>
          <span v-if='damage_code_result.code_type == 3'>小标</span>
        </p>
      </a-form-item>
      <a-form-item label="替换二维码" name='replace_code_sn'  :wrapper-col="{span: 20}">
        <a-input class='width60 m-r-15' style="width:200px" v-model:value="replace_code_sn" placeholder="请输入替换二维码" />
        <a-button type="primary" @click='replaceCode' :disabled="!damage_code_sn">确定</a-button>
        <div v-if='replace_show'>
          <p>检测到替换二维码已存在以下套标关系：</p>
          <a-descriptions layout="vertical" bordered>
            <a-descriptions-item label="大标">{{replace_code_result.big_code[0]}}</a-descriptions-item>
            <a-descriptions-item label="中标">
              <p class="text-ac s_lin_h30" v-for="(item,index) in replace_code_result.middle_code_data" :key='index'>{{item}}</p>
            </a-descriptions-item>
            <a-descriptions-item label="小标">
                <p class="text-ac s_lin_h30"  v-for="(item,index) in replace_code_result.small_code_data" :key='index'>{{item}}</p>
            </a-descriptions-item>
          </a-descriptions>
          <p>若替换，将解除替换二维码的套标关系，此操作不可逆，请谨慎！确定需要替换吗？</p>
        </div>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 2, offset: 3 }">
        <a-button type="primary" block v-has:antiCodeReplace="onSubmit" :disabled="!replace_code_sn || !replace_code_sn">替换</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import { ref, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { setReplace,replaceConfirm} from '@/api/antiFleeing';
export default {
  setup() {
    const state = reactive({
      labelCol: {span: 3},
      wrapperCol: {span: 12},
      damage_code_sn:'', // 损坏二维码
      replace_code_sn:'', // 替换二维码
      damage_code_result:{}, // 损坏二维码信息
      replace_code_result:{}, // 替换二维码信息
      damage_show:false, // 是否显示损坏二维码信息
      replace_show:false, // 是否显示替换二维码信息
    });
    //损坏二维码确定
    const damageCode = async () => {
      if (!state.damage_code_sn) {
        return message.error("请输入损坏二维码");
      }
      const hide = message.loading("正在加载中...", 0);
      let res = await replaceConfirm({type:1,damage_code_sn:state.damage_code_sn,replace_code_sn:state.replace_code_sn}).then(res => res.data).catch(error => error);
      if (iscode(res)) {
        state.damage_code_result = res.data;
        state.damage_show = true
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    }
    //替换二维码确定
    const replaceCode = async () => {
      if (!state.replace_code_sn) {
        return message.error("请输入替换二维码");
      }
      const hide = message.loading("正在加载中...", 0);
      let res = await replaceConfirm({type:2,damage_code_sn:state.damage_code_sn,replace_code_sn:state.replace_code_sn}).then(res => res.data).catch(error => error);
      if (iscode(res)) {
        state.replace_code_result = res.data;
        state.replace_show = true
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    }
    //替换
    const onSubmit = async () => {
      if (!state.damage_code_sn) {
        return message.error("请输入损坏二维码");
      }
      if (!state.replace_code_sn) {
        return message.error("请输入替换二维码");
      }
      if(state.damage_code_sn == state.replace_code_sn){
        return message.error("损坏二维码和替换二维码不能相同!");
      }
      const hide = message.loading("正在加载中...", 0);
      let res = await setReplace({type:2,damage_code_sn:state.damage_code_sn,replace_code_sn:state.replace_code_sn}).then(res => res.data).catch(error => error);
      if (iscode(res)) {
        message.success(res.msg);
        state.damage_code_sn = '';
        state.replace_code_sn = '';
        state.damage_show = true;
        state.replace_show = true;
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    }
    return {
      ...toRefs(state),
        onSubmit,
        damageCode,
        replaceCode
    };
  },
};
</script>
